/* tslint:disable */
/* eslint-disable */
/**
 * Commerce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProductSplashDiscountModel
 */
export interface ProductSplashDiscountModel {
    /**
     * 
     * @type {string}
     * @memberof ProductSplashDiscountModel
     */
    label?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductSplashDiscountModel
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductSplashDiscountModel
     */
    currency?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProductSplashDiscountModel
     */
    isPercentage?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ProductSplashDiscountModel
     */
    to?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ProductSplashDiscountModel
     */
    from?: Date;
}

/**
 * Check if a given object implements the ProductSplashDiscountModel interface.
 */
export function instanceOfProductSplashDiscountModel(value: object): boolean {
    return true;
}

export function ProductSplashDiscountModelFromJSON(json: any): ProductSplashDiscountModel {
    return ProductSplashDiscountModelFromJSONTyped(json, false);
}

export function ProductSplashDiscountModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductSplashDiscountModel {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'] == null ? undefined : json['label'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'currency': json['currency'] == null ? undefined : json['currency'],
        'isPercentage': json['isPercentage'] == null ? undefined : json['isPercentage'],
        'to': json['to'] == null ? undefined : (new Date(json['to'])),
        'from': json['from'] == null ? undefined : (new Date(json['from'])),
    };
}

export function ProductSplashDiscountModelToJSON(value?: ProductSplashDiscountModel | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'label': value['label'],
        'amount': value['amount'],
        'currency': value['currency'],
        'isPercentage': value['isPercentage'],
        'to': value['to'] == null ? undefined : ((value['to'] as any).toISOString()),
        'from': value['from'] == null ? undefined : ((value['from'] as any).toISOString()),
    };
}

